export default class CustomField {
  constructor({
    name,
    value = null
  }) {
    this.name = name
    this.value = value
  }


}